import { useState } from "react";
import DetailsDialog, { DetailsProps } from "../DetailsDialog";
import NumberInputField from "../ui/NumberInputField";
import TextInputField from "../ui/TextInputField";
import { SpringMaterialModel } from "../../api/SpringMaterialApi";

interface Properties
extends DetailsProps {
  purpose: 'BONNELL'|'POCKET';
}

const DIAMETER_X_HEIGHT_NAME_REGEX = /(\d+)x(\d+)/;

const SpringMaterialDetails = (properties: Properties) => {
  const purpose = properties.purpose;
  const [name, setName] = useState<string>();
  const [diameter, setDiameter] = useState<number>();
  const [height, setHeight] = useState<number>();
  const [thickness, setThickness] = useState<number>();
  
  const initializeFields = (data: SpringMaterialModel) => {
    setName(data.name);
    setDiameter(data.diameter);
    setHeight(data.height);
    setThickness(data.thickness);
  };

  const setDiameterIfNumber = (diameter: number) => {
    if (Number.isFinite(diameter)) {
      setDiameter(diameter);
    }
  };

  const setHeightIfNumber = (height: number) => {
    if (Number.isFinite(height)) {
      setHeight(height);
    }
  };

  const calculateAndSetDiameterWithHeight = (name: string) => {
    const match = name.match(DIAMETER_X_HEIGHT_NAME_REGEX);
    if (match) {
      setDiameterIfNumber(Number(match[1]));
      setHeightIfNumber(Number(match[2]));
    }
  };

  const handleNameChange = (name: string) => {
    setName(name);
    calculateAndSetDiameterWithHeight(name);
  };
  
  const collectData = () => (name && diameter && height && thickness)
    ? { name, diameter, height, thickness, purpose }
    : null;

  const renderFields = (initialData: SpringMaterialModel|undefined) => (
    <>
      <h2>Wprowadź dane sprężyny</h2>
      <TextInputField
        label='Nazwa'
        autoFocus
        initialValue={initialData?.name}
        onValueChange={handleNameChange}
      />
      <NumberInputField
        label='Średnica sprężyny [mm]'
        initialValue={initialData?.diameter}
        calculatedValue={diameter}
        onValueChange={setDiameter}
        />
      <NumberInputField
        label='Wysokość sprężyny [mm]'
        initialValue={initialData?.height}
        calculatedValue={height}
        onValueChange={setHeight}
        />
      <NumberInputField
        label='Średnica (grubość) drutu [mm]'
        initialValue={initialData?.thickness}
        onValueChange={setThickness}
      />
    </>
  );

  return (
    <DetailsDialog<SpringMaterialModel>
      { ...properties }
      resource='spring-materials'
      renderFields={ renderFields }
      initializeFields={ initializeFields }
      collectData={ collectData }
    />
  );
};
export default SpringMaterialDetails;